<div [ngClass]="{'order-entry__panel-more__auto-fwd-pricing__container': true}">
  <p-checkbox
    class="bfx-checkbox-bold-sm bfx-checkbox-bold-unsized"
    [label]="data.label"
    [binary]="true"
    [disabled]="data.locked || !data.enabled"
    [(ngModel)]="data.value"
    (ngModelChange)="onValueChange()"
  >
  </p-checkbox>
</div>
